import { IPlatformsEligibility } from '@sitegen/common/classes/friends-referral-api';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const hasSingleEligiblePlatform = (platforms: IPlatformsEligibility) => {
    return getEligiblePlatforms(platforms).length === 1;
};

export const getEligiblePlatforms = (platforms: IPlatformsEligibility): PLATFORM_TYPES[] => {
    return (Object.keys(platforms) as PLATFORM_TYPES[]).filter(key => platforms[key]);
};
